;(function (window, $) {
  $.externalLinkWarning = (function () {
    var selector = '.modal-wrapper.external_link_warning'
    var whitelist = PetRescue.env.externalLinks.whitelist
    var href

    return {
      initialized: false,
      init: function () {
        if (!this.initialized) {
          this.initialized = true
          bindEvents()
        }
      },
      try: function (a) {
        var deferred = $.Deferred()
        var $a = $(a)

        this.init()

        if (whitelist.indexOf($a.prop('hostname')) === -1) {
          href = $a.prop('href')
          $(selector).find('.link-preview').text(href)
          $(selector).show()
          deferred.resolve()
        } else {
          deferred.reject()
        }

        return deferred.promise()
      },
    }

    function bindEvents() {
      $(selector).on('click', '.button.accept', function () {
        $(document).trigger('close_modal')
        window.open(href)
      })

      $(selector).on('click', '.button.decline', function () {
        $(document).trigger('close_modal')
      })
    }
  })()
})(window, jQuery)
